import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import DataDictionary from './DataDictionary';
import DataModel from './DataModel';
import Methods from './Methods';
import PlayEngine from './PlayEngine';
import Skills from './Skills';
import { AuthProvider } from './AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const path = window.location.pathname;
const isPrivacyPolicy = path === '/privacy-policy';
const isDataDictionary = path === '/data-dictionary';
const isDataModel = path === '/data-model';
const isMethods = path === '/methods';
const isPlayEngine = path === '/play-engine';
const isSkills = path === '/skills';

root.render(
  <React.StrictMode>
    {isPrivacyPolicy ? (
      <PrivacyPolicy />
    ) : isDataDictionary ? (
      <DataDictionary />
    ) : isDataModel ? (
      <DataModel />
    ) : isMethods ? (
      <Methods />
    ) : isPlayEngine ? (
      <PlayEngine />
    ) : isSkills ? (
      <Skills />
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
